var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{staticClass:"stroke-color",attrs:{"fill":"none","stroke":"#055A7F","stroke-linecap":"round","stroke-width":"2","d":"M9 6l6.007 5.993L9 18"}})
}
var staticRenderFns = []

export { render, staticRenderFns }